<template src="./template.html"></template>
<style lang="scss" src="./styles.scss" scoped></style>

<script>
  import { mapActions } from 'vuex'
  import { differenceWith } from 'lodash'
  import FallbackAvatar from '@/components/ui/FallbackAvatar'

  export default {
    name: 'ChatNewMessage',
    components: {
      FallbackAvatar,
    },
    data() {
      return {
        users: [],
        model: [],
        search: null,
      }
    },
    computed: {
      items() {
        return this.users.map(user => {
          const name = this.displayUserName(user)
          return Object.assign({}, { text: name, value: user.id })
        })
      },
      getUsers() {
        return this.users
      },
    },
    watch: {
      search(val) {
        this.fetchUsers(val)
      },
      model(val) {
        this.search = ''
      },
    },
    created() {
      this.fetchUsers('')
    },
    methods: {
      ...mapActions('chat', ['chat']),
      async fetchUsers(search) {
        const chat = await this.chat()
        const usersRequest = chat.users(search)
        usersRequest && usersRequest.then(({ data }) => {
          this.users = differenceWith(data, this.model, (arrVal, othVal) => arrVal.id === othVal)
          this.$nextTick(() => {
            this.$refs.userSearch.$el.querySelector('input') && this.$refs.userSearch.$el.querySelector('input').focus()
          })
        })
      },
    },
  }
</script>
